function showFabricCanvasLoader() {
  jQuery('#fabricCanvasLoader').show();
}

function hideFabricCanvasLoader() {
  jQuery('#fabricCanvasLoader').fadeOut(300);
}


var text,fontSize, fontFamily, fSize, activeCOLOR, newText, zoom, cWidth = 1000, cHeight = 700,
    halfWidth = cWidth / 2, halfHeight = cHeight / 2,
    obj, array = [], get_data, sizeCrop,
    scale_factor, newheight, leftOb, imageUrl,img,
    leftMarker, rightMarker, vLine;

var loader = jQuery('#customLoader'),
    cropper = "", boxWidth, boxLeft, boxTop,
    croppedSize, orientations, aspectRatio, reCroper,
    c1img1;

var outLine,sizeBmW = 715, sizeBmH = 450,
    sizeB1W = 395, sizeB1H = 338,
    sizeB2W = 250, sizeB2H = 63;


imageUrl = document.getElementById('imageContainer').getAttribute('data-image-url');


$(document).ready(function() {

  currentImage = null; 

  function loadImage(url) {
    if (currentImage) {
      canvas2.remove(currentImage);
    }
    fabric.Image.fromURL(url, function(img) {
      img.set({
        left: halfWidth,
        top: halfHeight,
        selectable: false
      });
      // img.scale(.6);
      canvas2.add(img);
      currentImage = img; 
      img.sendToBack();
      // window['text1Page'].bringToFront();
      canvas2.renderAll();
    }, { crossOrigin: 'anonymous' });
  }

  var defaultUrl = $('#base1 img').attr('data-src');
  if(defaultUrl) {
    loadImage(defaultUrl);
  }

  
  // On style change
  jQuery(document).on('change', 'input[name="Style"]', function(e) {
    var selectedVal = $(this).val();

    if (selectedVal === 'Black Base (Big Size: Height 8 Width 5.5 inches)') {
      var blackUrl = $('#base1 img').attr('data-src');
      loadImage(blackUrl);
    } else {
      var woodenUrl = $('#base2 img').attr('data-src');
      loadImage(woodenUrl);
    }
  });

});



let starimage = document.querySelector("#stars_background");
let starBackground = new fabric.Image(starimage, {
  left:89,   
  top: 56,
  selectable: false
});
starBackground.scaleToWidth('814');

window['canvas2'] = new fabric.Canvas('canvas2', {
  width: cWidth,
  height: cHeight
});


window['canvas2'].add(starBackground);
starBackground.sendToBack();

showFabricCanvasLoader();

addModify(window['canvas2']);

let canvasInitialRenderDone = false;

function markCanvasReady() {
  if (canvasInitialRenderDone) return;
  canvasInitialRenderDone = true;
  hideFabricCanvasLoader();
}


/* ===============================
   FABRIC CANVAS LOADER
================================ */

function showFabricCanvasLoader() {
  jQuery("#fabricCanvasLoader").show();
}

function hideFabricCanvasLoader() {
  jQuery("#fabricCanvasLoader").fadeOut(300);
}

/* ===============================
   MAIN INIT
================================ */

(function () {
  function initMoonCustomizer() {

    

    /* ===============================
       REQUIRED GLOBALS
    ================================ */

    let pickedCoords = null;
    let lastQueryId = 0;

    const moonObjects = window.moonObjects = {};
    let baseMoonImage = null;

    let pickedTimezone = "Asia/Karachi";
    let timezoneRequestId = 0;

    const locationInput = document.getElementById("user_location");
    const suggestions = document.getElementById("suggestions");

    /* ===============================
       REAL MOON PHASE ENGINE
    ================================ */

    const RAD = Math.PI / 180;
    const DAY_MS = 1000 * 60 * 60 * 24;
    const J1970 = 2440588;
    const J2000 = 2451545;
    const EARTH_OBLIQUITY = RAD * 23.4397;

    function toJulian(date) {
      return date.valueOf() / DAY_MS - 0.5 + J1970;
    }

    function toDays(date) {
      return toJulian(date) - J2000;
    }

    function rightAscension(l, b) {
      return Math.atan2(
        Math.sin(l) * Math.cos(EARTH_OBLIQUITY) -
          Math.tan(b) * Math.sin(EARTH_OBLIQUITY),
        Math.cos(l)
      );
    }

    function declination(l, b) {
      return Math.asin(
        Math.sin(b) * Math.cos(EARTH_OBLIQUITY) +
          Math.cos(b) * Math.sin(EARTH_OBLIQUITY) * Math.sin(l)
      );
    }

    function solarMeanAnomaly(d) {
      return RAD * (357.5291 + 0.98560028 * d);
    }

    function eclipticLongitude(M) {
      const C =
        RAD *
        (1.9148 * Math.sin(M) +
          0.02 * Math.sin(2 * M) +
          0.0003 * Math.sin(3 * M));

      const P = RAD * 102.9372;

      return M + C + P + Math.PI;
    }

    function sunCoords(d) {
      const M = solarMeanAnomaly(d);
      const L = eclipticLongitude(M);

      return {
        ra: rightAscension(L, 0),
        dec: declination(L, 0),
        dist: 149598000
      };
    }

    function moonCoords(d) {
      const L = RAD * (218.316 + 13.176396 * d);
      const M = RAD * (134.963 + 13.064993 * d);
      const F = RAD * (93.272 + 13.22935 * d);

      const l = L + RAD * 6.289 * Math.sin(M);
      const b = RAD * 5.128 * Math.sin(F);
      const dist = 385001 - 20905 * Math.cos(M);

      return {
        ra: rightAscension(l, b),
        dec: declination(l, b),
        dist: dist
      };
    }

    function getRealMoonData(date) {
      const d = toDays(date);
      const s = sunCoords(d);
      const m = moonCoords(d);

      const phi = Math.acos(
        Math.sin(s.dec) * Math.sin(m.dec) +
          Math.cos(s.dec) * Math.cos(m.dec) * Math.cos(s.ra - m.ra)
      );

      const inc = Math.atan2(
        s.dist * Math.sin(phi),
        m.dist - s.dist * Math.cos(phi)
      );

      const angle = Math.atan2(
        Math.cos(s.dec) * Math.sin(s.ra - m.ra),
        Math.sin(s.dec) * Math.cos(m.dec) -
          Math.cos(s.dec) * Math.sin(m.dec) * Math.cos(s.ra - m.ra)
      );

      const fraction = (1 + Math.cos(inc)) / 2;

      let phase = 0.5 + (0.5 * inc * (angle < 0 ? -1 : 1)) / Math.PI;

      if (phase < 0) phase += 1;
      if (phase > 1) phase -= 1;

      return {
        phase: phase,
        fraction: fraction,
        angle: angle,
        name: getMoonPhaseName(phase),
        illuminationPercent: Math.round(fraction * 100)
      };
    }

    function getMoonPhaseName(phase) {
      if (phase < 0.03 || phase > 0.97) return "New Moon";
      if (phase < 0.22) return "Waxing Crescent";
      if (phase < 0.28) return "First Quarter";
      if (phase < 0.47) return "Waxing Gibbous";
      if (phase < 0.53) return "Full Moon";
      if (phase < 0.72) return "Waning Gibbous";
      if (phase < 0.78) return "Last Quarter";
      return "Waning Crescent";
    }

    /* ===============================
       TIMEZONE SUPPORT
    ================================ */

    function fallbackTimezoneFromCoords(lat, lon) {
      if (lat >= 23 && lat <= 38 && lon >= 60 && lon <= 78) {
        return "Asia/Karachi";
      }

      return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
    }

    async function getTimezoneFromCoords(lat, lon) {
      try {
        const res = await fetch(
          `https://timeapi.io/api/timezone/coordinate?latitude=${lat}&longitude=${lon}`
        );

        if (!res.ok) throw new Error("Timezone API failed");

        const data = await res.json();

        return data.timeZone || data.id || data.name || fallbackTimezoneFromCoords(lat, lon);
      } catch (err) {
        console.warn("Timezone lookup failed. Fallback timezone used.", err);
        return fallbackTimezoneFromCoords(lat, lon);
      }
    }

    async function updateTimezoneForCoords(lat, lon) {
      const requestId = ++timezoneRequestId;
      const tz = await getTimezoneFromCoords(lat, lon);

      if (requestId === timezoneRequestId && tz) {
        pickedTimezone = tz;
      }
    }

    function getTimeZoneOffsetMs(date, timeZone) {
      const dtf = new Intl.DateTimeFormat("en-US", {
        timeZone: timeZone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hourCycle: "h23"
      });

      const parts = dtf.formatToParts(date);
      const vals = {};

      parts.forEach(part => {
        if (part.type !== "literal") {
          vals[part.type] = part.value;
        }
      });

      const asUTC = Date.UTC(
        Number(vals.year),
        Number(vals.month) - 1,
        Number(vals.day),
        Number(vals.hour),
        Number(vals.minute),
        Number(vals.second)
      );

      return asUTC - date.getTime();
    }

    function makeDateInTimezone(dateStr, timeZone) {
      const utcGuess = new Date(`${dateStr}T12:00:00Z`);
      const offset = getTimeZoneOffsetMs(utcGuess, timeZone);
      return new Date(utcGuess.getTime() - offset);
    }

    /* ===============================
       REAL MOON IMAGE BUILDER
       Gradient colors are unchanged.
    ================================ */

    function buildRealMoonCanvas(
  baseImageEl,
  moonData,
  style,
  textureRotationDeg = 0
) {
  const SIZE = 1150;
  const R = SIZE / 2;
  const TWO_PI = Math.PI * 2;

  const EDGE_CUT = 65;
  const MOON_R = R - EDGE_CUT;

  /*
   * Create one independently rotated texture.
   */
  const TEXTURE_ROTATION_RAD =
    textureRotationDeg * Math.PI / 180;

  const sourceTextureCanvas =
    document.createElement("canvas");

  sourceTextureCanvas.width = SIZE;
  sourceTextureCanvas.height = SIZE;

  const sourceTextureCtx =
    sourceTextureCanvas.getContext("2d");

  sourceTextureCtx.clearRect(
    0,
    0,
    SIZE,
    SIZE
  );

  sourceTextureCtx.drawImage(
    baseImageEl,
    0,
    0,
    SIZE,
    SIZE
  );

  const rotatedTextureCanvas =
    document.createElement("canvas");

  rotatedTextureCanvas.width = SIZE;
  rotatedTextureCanvas.height = SIZE;

  const rotatedTextureCtx =
    rotatedTextureCanvas.getContext("2d");

  rotatedTextureCtx.clearRect(
    0,
    0,
    SIZE,
    SIZE
  );

  rotatedTextureCtx.save();

  rotatedTextureCtx.translate(R, R);
  rotatedTextureCtx.rotate(TEXTURE_ROTATION_RAD);

  rotatedTextureCtx.drawImage(
    sourceTextureCanvas,
    -R,
    -R,
    SIZE,
    SIZE
  );

  rotatedTextureCtx.restore();

  const canvas = document.createElement("canvas");
  canvas.width = SIZE;
  canvas.height = SIZE;

  const ctx = canvas.getContext("2d");
  ctx.clearRect(0, 0, SIZE, SIZE);

  // Dark moon layer
  ctx.save();

  ctx.beginPath();
  ctx.arc(R, R, MOON_R, 0, TWO_PI);
  ctx.clip();

  ctx.filter =
    "contrast(1.12) brightness(1.03)";

  ctx.drawImage(
    rotatedTextureCanvas,
    0,
    0,
    SIZE,
    SIZE
  );

  ctx.filter = "none";

  ctx.fillStyle = "rgba(0,0,0,0.72)";
  ctx.fillRect(0, 0, SIZE, SIZE);

  const earthshine = ctx.createRadialGradient(
    R,
    R,
    MOON_R * 0.05,
    R,
    R,
    MOON_R
  );

  earthshine.addColorStop(
    0,
    "rgba(160,180,255,0.07)"
  );

  earthshine.addColorStop(
    0.65,
    "rgba(90,110,180,0.035)"
  );

  earthshine.addColorStop(
    1,
    "rgba(0,0,0,0)"
  );

  ctx.fillStyle = earthshine;
  ctx.fillRect(0, 0, SIZE, SIZE);

  ctx.restore();

  // Bright moon layer
  const lightCanvas =
    document.createElement("canvas");

  lightCanvas.width = SIZE;
  lightCanvas.height = SIZE;

  const lctx = lightCanvas.getContext("2d");

  lctx.clearRect(0, 0, SIZE, SIZE);

  lctx.save();

  lctx.beginPath();
  lctx.arc(R, R, MOON_R, 0, TWO_PI);
  lctx.clip();

  lctx.filter =
    "contrast(1.15) brightness(1.04)";

  lctx.drawImage(
    rotatedTextureCanvas,
    0,
    0,
    SIZE,
    SIZE
  );

  lctx.filter = "none";

  /*
   * Continue your existing colour-gradient,
   * illumination-mask, feather and glow code here.
   */

  let gradient;

  if (style === "gold") {
    gradient = lctx.createRadialGradient(R * 0.35, R * 0.35, MOON_R * 0.1, R, R, MOON_R);
    gradient.addColorStop(0, "rgba(255,240,200,0.65)");
    gradient.addColorStop(0.6, "rgba(255,201,120,0.4)");
    gradient.addColorStop(1, "rgba(255,201,120,0.25)");
  } else if (style === "silver") {
    gradient = lctx.createRadialGradient(R * 0.35, R * 0.35, MOON_R * 0.1, R, R, MOON_R);
    gradient.addColorStop(0, "rgba(255,255,255,0.22)");
    gradient.addColorStop(0.6, "rgba(220,220,220,0.12)");
    gradient.addColorStop(1, "rgba(180,180,180,0.02)");
  } else {
    gradient = lctx.createRadialGradient(R * 0.35, R * 0.35, MOON_R * 0.1, R, R, MOON_R);
    gradient.addColorStop(0, "rgba(180,210,255,0.56)");
    gradient.addColorStop(0.6, "rgba(120,161,255,0.43)");
    gradient.addColorStop(1, "rgba(80,110,220,0.30)");
  }

  lctx.fillStyle = gradient;
  lctx.fillRect(0, 0, SIZE, SIZE);

  lctx.restore();

  // Illumination mask
  const maskCanvas = document.createElement("canvas");
  maskCanvas.width = SIZE;
  maskCanvas.height = SIZE;

  const mctx = maskCanvas.getContext("2d");
  const imageData = mctx.createImageData(SIZE, SIZE);
  const data = imageData.data;

  const phase = moonData.phase;
  const elongation = phase * TWO_PI;
  const phaseAngle = Math.abs(Math.PI - elongation);

  const side = phase <= 0.5 ? 1 : -1;

  const sx = side * Math.sin(phaseAngle);
  const sz = Math.cos(phaseAngle);

  /*
 * Keeps the light/shadow direction vertical and makes the
 * shadow boundary and its top/bottom corners smoother.
 */
const TERMINATOR_SOFTNESS = 0.04;
const LIMB_SOFTNESS = 0.012;

function smoothstep(edge0, edge1, value) {
  const t = Math.max(
    0,
    Math.min(1, (value - edge0) / (edge1 - edge0))
  );

  return t * t * (3 - 2 * t);
}

for (let y = 0; y < SIZE; y++) {
  for (let x = 0; x < SIZE; x++) {
    const nx = (x - R) / MOON_R;
    const ny = (y - R) / MOON_R;
    const rr = nx * nx + ny * ny;

    const index = (y * SIZE + x) * 4;

    if (rr >= 1) {
      data[index] = 255;
      data[index + 1] = 255;
      data[index + 2] = 255;
      data[index + 3] = 0;
      continue;
    }

    const nz = Math.sqrt(Math.max(0, 1 - rr));

    /*
     * There is no Y-axis lighting component.
     * Therefore, the terminator stays vertically aligned.
     */
    const dot = nx * sx + nz * sz;

    // Smooth light-to-shadow transition.
    const terminatorAlpha = smoothstep(
      -TERMINATOR_SOFTNESS,
      TERMINATOR_SOFTNESS,
      dot
    );

    /*
     * Softens the points where the shadow boundary meets
     * the outer circular edge of the moon.
     */
    const distanceToLimb = 1 - Math.sqrt(rr);

    const limbAlpha = smoothstep(
      0,
      LIMB_SOFTNESS,
      distanceToLimb
    );

    const alpha = terminatorAlpha * limbAlpha;

    data[index] = 255;
    data[index + 1] = 255;
    data[index + 2] = 255;
    data[index + 3] = Math.round(alpha * 255);
  }
}

  mctx.putImageData(imageData, 0, 0);

  lctx.globalCompositeOperation = "destination-in";
  lctx.drawImage(maskCanvas, 0, 0);
  lctx.globalCompositeOperation = "source-over";

  ctx.drawImage(lightCanvas, 0, 0);


  /* ===============================
   SMOOTH MOON EDGE / SOFTNESS
================================ */

const EDGE_FEATHER = 45; 
// 20 = less smooth
// 32 = recommended
// 45 = very soft edge

ctx.save();
ctx.globalCompositeOperation = "destination-in";

const smoothEdge = ctx.createRadialGradient(
  R,
  R,
  MOON_R - EDGE_FEATHER,
  R,
  R,
  MOON_R
);

smoothEdge.addColorStop(0, "rgba(255,255,255,1)");
smoothEdge.addColorStop(0.65, "rgba(255,255,255,1)");
smoothEdge.addColorStop(1, "rgba(255,255,255,0)");

ctx.fillStyle = smoothEdge;
ctx.fillRect(0, 0, SIZE, SIZE);

ctx.restore();



/* ===============================
   SOFT OUTER GLOW LIKE REFERENCE
================================ */

let selectedGlowColor;

if (style === "gold") {
  selectedGlowColor = "rgba(255, 205, 115, 0.32)";
} else if (style === "silver") {
  selectedGlowColor = "rgba(255, 255, 255, 0.24)";
} else {
  selectedGlowColor = "rgba(135, 170, 255, 0.28)";
}

const OUTER_GLOW_SIZE = 38;
// 25 = small glow
// 38 = reference style
// 50 = stronger glow

ctx.save();
ctx.globalCompositeOperation = "destination-over";

const outerSmoothGlow = ctx.createRadialGradient(
  R,
  R,
  MOON_R - 4,
  R,
  R,
  MOON_R + OUTER_GLOW_SIZE
);

outerSmoothGlow.addColorStop(0, selectedGlowColor);
outerSmoothGlow.addColorStop(0.45, "rgba(255,255,255,0.12)");
outerSmoothGlow.addColorStop(1, "rgba(255,255,255,0)");

ctx.fillStyle = outerSmoothGlow;
ctx.fillRect(0, 0, SIZE, SIZE);

ctx.restore();




  return canvas;
}

    /* ===============================
       RENDER TWO MOONS
    ================================ */

    function renderMoon(id, lat, lon, dateObj, style, left, top) {
      if (!baseMoonImage) return;

      const moonData = getRealMoonData(dateObj);

      if (moonObjects[id]) {
        canvas2.remove(moonObjects[id]);
        moonObjects[id] = null;
      }

      const baseImageEl = baseMoonImage.getElement();
      const textureRotationDeg = getMoonRotation(lat, lon, dateObj);

      const realMoonCanvas = buildRealMoonCanvas(
        baseImageEl,
        moonData,
        style,
        textureRotationDeg
      );

      moonObjects[id] = new fabric.Image(realMoonCanvas, {
        left: left,
        top: top,
        originX: "center",
        originY: "center",
        selectable: false,
        evented: false,
        scaleX: MOON_LAYOUT.scale,
        scaleY: MOON_LAYOUT.scale,
        angle: 0,
        objectCaching: false
      });

      canvas2.add(moonObjects[id]);
      moonObjects[id].bringToFront();
      canvas2.requestRenderAll();

      console.log(
        `Moon ${id}: ${moonData.name}, ` +
        `${moonData.illuminationPercent}% illuminated, ` +
        `phase=${moonData.phase.toFixed(4)}`
      );

      setTimeout(markCanvasReady, 300);
    }

    /* ===============================
       OPTIONAL ARTISTIC ROTATION
    ================================ */

    function getMoonRotation(lat, lon, date) {

    const rad = Math.PI / 180;

    // Julian day
    const JD = date.getTime() / 86400000 + 2440587.5;
    const T = (JD - 2451545.0) / 36525;

    // Mean obliquity
    const e =
        (23.439291 -
            0.0130042 * T) * rad;

    // Local sidereal time

    const GMST =
        280.46061837 +
        360.98564736629 *
            (JD - 2451545);

    const LST =
        ((GMST + lon) % 360) * rad;

    const moon = moonCoords(toDays(date));

    const H = LST - moon.ra;

    const q = Math.atan2(
        Math.sin(H),
        Math.tan(lat * rad) *
            Math.cos(moon.dec) -
            Math.sin(moon.dec) *
            Math.cos(H)
    );

    return q * 180 / Math.PI;
}

    /* ===============================
       UPDATE COORDINATES
    ================================ */

    function updateCoordinates(lat, lon) {
      const text = `${lat.toFixed(6)}, ${lon.toFixed(6)}`;

      const text3Input = document.getElementById("text_3");

      if (text3Input) {
        text3Input.value = text;
      }

      if (window.text3Page) {
        window.text3Page.set("text", text);
        canvas2.renderAll();
      }

      pickedCoords = { lat: lat, lon: lon };
    }

    /* ===============================
       UPDATE TWO MOONS
    ================================ */

    /* ===============================
       THREE-MOON LAYOUT
       Keep all three moons perfectly centered as a group.
       The same X positions are reused by the name labels.
    ================================ */
        const MOON_LAYOUT = {
      centerX: 500,

      // Landscape layout: title -> moons -> names -> coordinates -> quote
      titleTop: 120,
      centerY: 300,
      nameTop: 430,

      // Moon sizing / horizontal spacing.
      // The three centers remain symmetrical around canvas center (1000).
      sideGap: 20,
      scale: 0.18,

      // Name text box is centered on exactly the same X as its moon.
      nameWidth: 180
    };

    // The moon canvas is 1150px wide. At this scale the visible
    // moon diameter is approximately 276px, so 35px of clear gap
    // is maintained between neighboring moons.
    const MOON_DIAMETER = 1150 * MOON_LAYOUT.scale;
    const MOON_STEP = MOON_DIAMETER + MOON_LAYOUT.sideGap;

    const MOON_X = [
      MOON_LAYOUT.centerX - MOON_STEP,
      MOON_LAYOUT.centerX,
      MOON_LAYOUT.centerX + MOON_STEP
    ];

    function updateMoon() {
      if (!pickedCoords) return;

      const moons = [
        { id: 1, date: "moon_date",  style: "moon_style",  left: MOON_X[0], top: MOON_LAYOUT.centerY },
        { id: 2, date: "moon_date2", style: "moon_style2", left: MOON_X[1], top: MOON_LAYOUT.centerY },
        { id: 3, date: "moon_date3", style: "moon_style3", left: MOON_X[2], top: MOON_LAYOUT.centerY }
      ];

      moons.forEach(function(moon) {
        const dateInput = document.getElementById(moon.date);
        if (!dateInput || !dateInput.value) return;

        const styleInput = document.getElementById(moon.style);
        const style = styleInput ? styleInput.value : "blue";
        const dateObj = makeDateInTimezone(
          dateInput.value,
          pickedTimezone || "Asia/Karachi"
        );

        renderMoon(
          moon.id,
          pickedCoords.lat,
          pickedCoords.lon,
          dateObj,
          style,
          moon.left,
          moon.top
        );
      });
    }

    window.updateMoon = updateMoon;
    window.updateCoordinates = updateCoordinates;

    /* ===============================
       LOAD BASE MOON IMAGE
    ================================ */

    const moonShapeEl = document.getElementById("moon_shape");

    if (moonShapeEl) {
      fabric.Image.fromURL(
        moonShapeEl.src,
        function (img) {
          img.set({
            originX: "center",
            originY: "center"
          });

          baseMoonImage = img;
          updateMoon();
        },
        {
          crossOrigin: "anonymous"
        }
      );
    }

    /* ===============================
       LOCATION AUTOCOMPLETE
    ================================ */

    if (locationInput && suggestions) {
      locationInput.addEventListener("input", async function (e) {
        const q = e.target.value.trim();

        suggestions.innerHTML = "";
        suggestions.style.display = "none";
        pickedCoords = null;

        if (q.length < 2) return;

        const queryId = ++lastQueryId;

        try {
          const res = await fetch(
            `https://nominatim.openstreetmap.org/search?format=json&limit=6&q=${encodeURIComponent(q)}`,
            {
              headers: {
                "Accept-Language": "en"
              }
            }
          );

          if (queryId !== lastQueryId) return;

          const data = await res.json();

          if (!data.length) return;

          suggestions.style.display = "block";

          data.forEach(function (p) {
            const div = document.createElement("div");
            div.className = "autocomplete-item";
            div.textContent = p.display_name;

            div.onclick = async function () {
              locationInput.value = p.display_name;

              pickedCoords = {
                lat: Number(p.lat),
                lon: Number(p.lon)
              };

              updateCoordinates(pickedCoords.lat, pickedCoords.lon);

              suggestions.style.display = "none";

              await updateTimezoneForCoords(pickedCoords.lat, pickedCoords.lon);

              updateMoon();
            };

            suggestions.appendChild(div);
          });
        } catch (err) {
          console.warn("Location API blocked", err);
        }
      });
    }

    /* ===============================
       TEXT 1 - TITLE
    ================================ */

       window["text1Page"] = new fabric.Text("Moonlit Souls", {
      left: MOON_LAYOUT.centerX,
      top: MOON_LAYOUT.titleTop,
      originX: "center",
      originY: "top",
      fontSize: 55,
      fontFamily: "Miguella Charlotte",
      fill: "#fff",
      lockMovementX: true,
      lockMovementY: true,
      hasControls: false
    });

    var fontName1 = window["text1Page"].fontFamily;
    jQuery(".choose_font1").val("'" + fontName1 + "'").trigger("change");

    canvas2.add(window["text1Page"]);

    const text1Input = document.getElementById("text_1");

    if (text1Input) {
      text1Input.addEventListener("focus", function () {
        if (window["text1Page"].text === "Moonlit Souls") {
          window["text1Page"].set("text", "");
          canvas2.renderAll();
        }
      });

        text1Input.addEventListener("input", function (e) {
        const newText = e.target.value;
        window["text1Page"].set("text", newText);
        fitTextToWidth(window["text1Page"], 640);
        window["text1Page"].bringToFront();
        canvas2.renderAll();
      });
    }

    function fitTextToWidth(textObj, maxWidth) {
      let fontSize = 55;
      textObj.set({ fontSize: fontSize });

      while (textObj.width > maxWidth && fontSize > 5) {
        fontSize -= 1;
        textObj.set({ fontSize: fontSize });
      }

      canvas2.renderAll();
    }

    /* ===============================
       MOON NAMES
    ================================ */

    function createMoonName(id, defaultText, left) {
      const obj = new fabric.Text(defaultText, {
        left: left,
        top: MOON_LAYOUT.nameTop,
        width: MOON_LAYOUT.nameWidth,
        fontSize: 22,
        fontFamily: "Lora",
        textAlign: "center",
        originX: "center",
        originY: "top",
        fill: "#fff",
        lockMovementX: true,
        lockMovementY: true,
        hasControls: false
      });

      window[id] = obj;
      canvas2.add(obj);
      return obj;
    }

    createMoonName("text4Page", "Hamza", MOON_X[0]);
    createMoonName("text5Page", "Fizza", MOON_X[1]);
    createMoonName("text6Page", "Asif", MOON_X[2]);

    function fitMoonName(textObj, maxWidth) {
      let fontSize = 22;
      textObj.set({ fontSize: fontSize });
      while (textObj.width > maxWidth && fontSize > 12) {
        fontSize -= 1;
        textObj.set({ fontSize: fontSize });
      }
      canvas2.renderAll();
    }

    [
      { input: "text_4", obj: "text4Page", placeholder: "Hamza" },
      { input: "text_5", obj: "text5Page", placeholder: "Fizza" },
      { input: "text_6", obj: "text6Page", placeholder: "Asif" }
    ].forEach(function(item) {
      const el = document.getElementById(item.input);
      if (!el) return;

      el.addEventListener("focus", function() {
        if (window[item.obj].text === item.placeholder) {
          window[item.obj].set("text", "");
          canvas2.renderAll();
        }
      });

      el.addEventListener("input", function(e) {
        window[item.obj].set({
          text: e.target.value,
          left: window[item.obj].left
        });
        fitMoonName(window[item.obj], MOON_LAYOUT.nameWidth);
      });
    });

   const namesFont = document.querySelector(".choose_font4");

if (namesFont) {

  // Force "Lora" as the selected font in the dropdown
  const loraOption = Array.from(namesFont.options).find(function(option) {
    return option.value === "Lora" ||
           option.text.trim().toLowerCase() === "lora";
  });

  if (loraOption) {
    namesFont.value = loraOption.value;
    jQuery(namesFont).trigger("change");
  }

  // Apply Lora to all three names
  ["text4Page", "text5Page", "text6Page"].forEach(function(id) {
    window[id].set("fontFamily", "Lora");
  });

  canvas2.renderAll();
}

    /* ===============================
       TEXT 3 - COORDINATES
    ================================ */

      window["text3Page"] = new fabric.Text("24.855368, 67.02053", {
      left: 500,
      top: 490,
      fontSize: 17,
      originX: "center",
      originY: "top",
      fontFamily: "Arial",
      fill: "#fff",
      lockMovementX: true,
      lockMovementY: true,
      hasControls: false
    });

    canvas2.add(window["text3Page"]);

    function fitTextToWidth3(textObj, maxWidth) {
      let fontSize = 17;
      textObj.set({ fontSize: fontSize });

      while (textObj.width > maxWidth && fontSize > 5) {
        fontSize -= 1;
        textObj.set({ fontSize: fontSize });
      }

      canvas2.renderAll();
    }

    const text3Input = document.getElementById("text_3");

    if (text3Input) {
      let coordUpdateTimer = null;

      text3Input.addEventListener("input", function () {
        const value = this.value.trim();

        window.text3Page.set("text", value);
        fitTextToWidth3(window["text3Page"], 1000);
        canvas2.renderAll();

        const parts = value.split(",");
        if (parts.length !== 2) return;

        const lat = parseFloat(parts[0].trim());
        const lon = parseFloat(parts[1].trim());

        if (isNaN(lat) || isNaN(lon)) return;
        if (lat < -90 || lat > 90 || lon < -180 || lon > 180) return;

        pickedCoords = { lat: lat, lon: lon };

        clearTimeout(coordUpdateTimer);

        coordUpdateTimer = setTimeout(async function () {
          await updateTimezoneForCoords(lat, lon);
          updateMoon();
        }, 400);
      });
    }

    /* ===============================
       TEXT 2 - DESCRIPTION
    ================================ */

    var maxWidth = 640;
    var maxHeight = 70;

    var para = "check";

      window["text2Page"] = new fabric.Text(para, {
      left: 500,
      top: 560,
      originX: "center",
      originY: "top",
      width: 660,
      fontSize: 27,
      fontFamily: "Dancing Script",
      textAlign: "center",
      textAlign: "center",
      lockMovementX: true,
      lockMovementY: true,
      hasControls: false,
      fill: "#fff"
    });

    var fontName2 = window["text2Page"].fontFamily;
    jQuery(".choose_font2").val("'" + fontName2 + "'").trigger("change");

    canvas2.add(window["text2Page"]);

    var minFontSize = 14;
    var maxFontSize = 27;

    const text2Input = document.getElementById("text_2");

    if (text2Input) {
      text2Input.addEventListener("focus", function () {
        if (
          window["text2Page"].text ===
          "Three souls, one beautiful story \nforever connected beneath the same moon."
        ) {
          window["text2Page"].set("text", "");
          canvas2.renderAll();
        }
      });

      text2Input.addEventListener("input", function (e) {
        const input = e.target.value;

        window["text2Page"].set({
          text: input
        });

        fitTextToBox(window["text2Page"], maxWidth, maxHeight);
      });
    }

    function fitTextToBox(textObj, maxWidth, maxHeight) {
      let fontSize = maxFontSize;

      textObj.set({ fontSize: fontSize });

      function isTooBig() {
        return textObj.width > maxWidth || textObj.height > maxHeight;
      }

      while (isTooBig() && fontSize > minFontSize) {
        fontSize -= 1;
        textObj.set({ fontSize: fontSize });
      }

      canvas2.renderAll();
    }

    /* ===============================
       WATERMARK
    ================================ */

      window["text55Page"] = new fabric.Text("@tasweer.com.pk", {
      left: 940,
      top: 670,
      fontSize: 11,
      fontFamily: "Baloo2",
      fill: "#fff",
      lockMovementX: true,
      lockMovementY: true,
      hasControls: false
    });

    canvas2.add(window["text55Page"]);

    /* ===============================
       FONT SHADE
    ================================ */

    function updateFontShade(mode) {
      window.textColor = mode === "light" ? "#000" : "#fff";

      const textarea = document.getElementById("text_0");

      if (!textarea || typeof drawSpiralLyricsSVG !== "function") return;

      const text = textarea.value.trim() || window.placeholderText;

      drawSpiralLyricsSVG(text);
    }

    jQuery(document).on("click", ".actionBtn", function () {
      if (jQuery(this).hasClass("darkColor")) {
        updateFontShade("dark");
      }

      if (jQuery(this).hasClass("lightColor")) {
        updateFontShade("light");
      }
    });

    /* ===============================
       MOON DATE / STYLE EVENTS
    ================================ */

    ["moon_date", "moon_date2", "moon_date3", "moon_style", "moon_style2", "moon_style3"].forEach(function(id) {
      const el = document.getElementById(id);
      if (el) {
        el.addEventListener("change", updateMoon);
        el.addEventListener("input", updateMoon);
      }
    });

    jQuery(document).on("change", ".fontFamily4", function() {
      const value = this.value;
      if (window.text4Page) window.text4Page.set("fontFamily", value);
      if (window.text5Page) window.text5Page.set("fontFamily", value);
      if (window.text6Page) window.text6Page.set("fontFamily", value);
      canvas2.renderAll();
    });

    /* ===============================
       DEFAULT INIT
    ================================ */

    if (locationInput) {
      locationInput.value = "Karachi";
    }

    pickedCoords = {
      lat: 24.8607,
      lon: 67.0011
    };

    pickedTimezone = "Asia/Karachi";

    updateCoordinates(pickedCoords.lat, pickedCoords.lon);

    const name1 = document.getElementById("text_4");
    const name2 = document.getElementById("text_5");
    const name3 = document.getElementById("text_6");
    if (name1 && name1.value) window.text4Page.set("text", name1.value);
    if (name2 && name2.value) window.text5Page.set("text", name2.value);
    if (name3 && name3.value) window.text6Page.set("text", name3.value);

    updateMoon();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initMoonCustomizer);
  } else {
    initMoonCustomizer();
  }
})();





function canvasMakeImg(canvas,zoom){
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function canvasBlock(canvas){
  zoom = jQuery('.product__media-outer').width();
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function setZoomMask(canvas,newZoomLevel){
  canvas.setZoom(newZoomLevel);
  canvas.setDimensions({
    width:  cWidth * newZoomLevel,
    height:  cHeight * newZoomLevel
  });
  canvas.renderAll();

  var wrapperEl = canvas.wrapperEl;
  if (wrapperEl) {
    wrapperEl.style.marginLeft = "auto";
    wrapperEl.style.marginRight = "auto";
    wrapperEl.style.display = "block";
  }
}

function addModify(canvas){
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;

  canvas.renderOnAddRemove = false;
  canvas.on('selection:cleared', function(e){
    object = e.target;
  });

  canvas.on('object:removed',function(e){
    object = e.target;
  });

  canvas.on('object:added', function(e){
    object = e.target;
    addControls(object);
    canvas.renderAll();
  });
  
  canvas.on('object:modified', function(e){
    object = e.target;
    canvas.renderAll();
  });
  
  canvas.on('selection:created', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('selection:updated', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('object:scaling', function(e){
    canvas.renderAll();
  });

}

// jQuery(window).on('load',function(){
  //   canvasBlock(canvas);
  //   loadFirstImg();
  // });

  jQuery(window).on('resize',function(){
    canvasBlock(window['canvas2']);
  });

function addControls(object){
  var iconTL = document.createElement("img"),
      iconBR = document.createElement("img");
  
  iconTL.src = trashIcon;
  iconBR.src = resizeIcon;
  
  object.set({
    selectable:false,
    originX:"center",
    originY:"center",
    transparentCorners: false,
    borderColor: '#ddd',
    borderDashArray: [6,2],
    cornerStyle: 'circle',
    cornerColor: '#fff',
    objectCaching: false,
    _controlsVisibility: {
      tr: false,
      tl: true,
      bl: false,
      br: true,
      mb: false,
      ml: false,
      mr: false,
      mt: false,
      mtr: false
    }
  });
  
  iconTL.onload = function() {
    fabric.Object.prototype.controls.tl = new fabric.Control({
      x: -0.5,
      y: -0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "pointer",
      mouseUpHandler: deleteHandler,
      render: renderIcon(iconTL),
      withConnection: true,
      cornerSize: 18,
    });
  };
  iconBR.onload = function() {
    fabric.Object.prototype.controls.br = new fabric.Control({
      x: 0.5,
      y: 0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "se-resize",
      mouseUpHandler:fabric.controlsUtils.scalingEqually,
      render: renderIcon(iconBR),
      withConnection: true,
      cornerSize: 18,
    });
  }
}

function renderIcon(icon) {
  return function (ctx, left, top, styleOverride, fabricObject) {
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}

function deleteHandler(eventData,transform){
  var target = transform.target;
  activeOb = canvas.getActiveObject();
  canvas.remove(activeOb);
  canvas.renderAll();
}

initCropper();

function readURL2(input){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  if(cropper == ""){
  }else {
    cropper.destroy();
  }
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function (e) {
      jQuery('#blah').attr('src', e.target.result);
      reCroper.attr('data-img',e.target.result);
    };
    reader.readAsDataURL(input.files[0]);
    setTimeout(initCropper, 2500);
  }
}

function addImage(e,placeholderimg,canvas){
  var file = e.target.files[0];
  var reader = new FileReader();
  reader.onload = function(event){
    var imgObj = new Image();
    imgObj.src = event.target.result;
    imgObj.onload = function(){
      var img = new fabric.Image(imgObj);
      img.set({
        left: placeholderimg.left,
        top: placeholderimg.top,
        selectable:true,
        scaleX: placeholderimg.width / img.width,
        scaleY: placeholderimg.height / img.height,
      });
      canvas.add(img);
    };
  };
  reader.readAsDataURL(file);
}

function addCroppedImg(imgurl){
  canvas.remove(img).renderAll();
  fabric.Image.fromURL(imgurl, function(newImg){
    newImg.set({
      left: img.left,
      top: img.top,
      selectable: img.selectable
    });
    newImg.scaleToHeight(available_height);
    canvas.add(newImg).renderAll();
    img = newImg;
    canvas.renderAll();
  });
}

function initCropper(){
  var image = document.getElementById('blah');
  cropper = new Cropper(image, {
    viewMode: 1,
    dragMode: 'move',
    aspectRatio: sizeCrop,
    restore: false,
    guides: false,
    center: true,
    highlight: true,
    cropBoxMovable: true,
    cropBoxResizable: true,
    toggleDragModeOnDblclick: false,
    data:{}
  });
  jQuery('.popupImg').show();
  jQuery('#tadaWidget').addClass('hidden');
  loader.addClass('hidden');
}

document.getElementById('crop_button').addEventListener('click', function(){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  var imgurl =  cropper.getCroppedCanvas().toDataURL();
  addCroppedImg(imgurl);
  setTimeout(function(){
    reCroper.parent().removeClass('hidden');
    jQuery('.popupImg').hide();
    loader.addClass('hidden');
    jQuery('#tadaWidget').removeClass('hidden');
  },500);
});

document.getElementById('zoom_out').addEventListener('click', function(){
  cropper.zoom(-0.1);
});

document.getElementById('zoom_in').addEventListener('click', function(){
  cropper.zoom(0.1);
});

document.getElementById('reset_button').addEventListener('click', function(){
  cropper.reset();
});

document.getElementById('cancelCropper').addEventListener('click', function(){
  jQuery('.popupImg').hide();
  jQuery('#tadaWidget').removeClass('hidden');
});

jQuery(document).on('click','.btnReCrop', function(){
  loader.removeClass('hidden');
  imgurl = jQuery(this).attr('data-img');
  sizeCrop = jQuery(this).attr('data-ratio');
  img = window[jQuery(this).attr('data-obj')];
  canvas = window[jQuery(this).attr('data-canvas')];
  available_height = jQuery(this).attr('data-height');
  console.log(canvas);
  jQuery('#tadaWidget').addClass('hidden');
  setTimeout(function(){
    cropper.destroy();
    jQuery('#blah').attr('src',imgurl);
    initCropper();
    jQuery('.popupImg').show();
    loader.addClass('hidden');
  },150);
});

jQuery('.customColors').each(function(){
  colorBox = jQuery(this).attr('id');
  loadColorPicker(colorBox);
});

jQuery(document).on('change','.fontFamily',function(){
  var fontID = jQuery(this).attr('data-canvas'),
      textOb = jQuery(this).attr('data-obj');
  canvas = window[fontID];
  activeOb = window[textOb];
  activeOb.set({ fontFamily: this.value });
  canvas.renderAll();
  // fitTextToWidth(window['text1Page'], 1200);
  // fitTextToBox(window['text2Page'], maxWidth, maxHeight);
});


function loadColorPicker(colorBox){
  jQuery('#'+colorBox).colorpicker({
    inline: true,
    container: true,
    extensions:[{
      name: 'swatches',
      options:{
        colors:{
          'tetrad1': 'transparent',
          'tetrad2': '#e30405',
          'tetrad3': '#197b30',
          'tetrad4': '#0054a5',
          'tetrad5': '#ffcc00',
          'tetrad6': '#f6ebbe',
          'tetrad7': '#ffea00',
          'tetrad8': '#f8931d',
          'tetrad9': '#f499c2',
          'tetrad10': '#959595',
          'tetrad11': '#fef335',
          'tetrad12': '#a0400d',
          'tetrad13': '#000000',
          'tetrad14': '#604973',
          'tetrad15': '#afe8fc',
          'tetrad16': '#fffafa',
          'tetrad17': '#bc8cbe',
          'tetrad18': '#ff69b4',
          'tetrad19': '#93278f',
          'tetrad20': '#009987',
          'tetrad21': '#0af447',
          'tetrad22': '#00008b',
          'tetrad23': '#006400'
        },
        namesAsValues: false
      }
    }],
    template: '<div class="colorpicker">' +
      '<div class="colorpicker-saturation"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-hue"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-alpha">' +
      '   <div class="colorpicker-alpha-color"></div>' +
      '   <i class="colorpicker-guide"></i>' +
      '</div>' +
      '<div class="colorpicker-bar">' +
      '   <a href="javascript:void(0);" class="button btn-block colorOFF">Ok</a>'+
      '   <div class="ctn-icon-eyedropper dropper-eyedrop"><svg class="icon icon-eyedropper" viewBox="0 0 16 16">'+
      '   <path d="M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708L8.293 5l-7.147 7.146A.5.5 0 0 0 1 12.5v1.793l-.854.853a.5.5'+
      '   0 1 0 .708.707L1.707 15H3.5a.5.5 0 0 0 .354-.146L11 7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207'+
      '   1.207 0 0 0 0-1.708zM2 12.707l7-7L10.293 7l-7 7H2z"/></svg></div>'+
      '</div>' +
      '</div>'
  }).on('colorpickerCreate', function(){
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('id'),
        active = colorBox.find('.currentColor'),
        activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
    },200);
  }).on('colorpickerChange', function(){
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('data-canvas'),
          textOb = colorBox.attr('data-obj'),
          active = colorBox.find('.currentColor'),
          activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
      colorBox.attr('data-color',activeCOLOR);
      canvas = window[colorID];
      activeOb = window[textOb];
      sCAle = activeOb.scaleX;
      activeOb.set('fill',activeCOLOR);
      activeOb.scaleX = .5;
      activeOb.setCoords();
      canvas.renderAll();
      activeOb.scaleX = sCAle;
      activeOb.setCoords();
      canvas.renderAll();
    },200);
  });
  jQuery(document).on('click','.colorBox',function(){
    jQuery('.colorBox').each(function(){
      jQuery(this).next().hide();
    });
    jQuery(this).next().show();
  });
  jQuery(document).on('click','.colorOFF',function(){
    var parENt = jQuery(this).parent().parent(),
        toolBarBox = parENt.parent().parent().parent().attr('id');
    if(toolBarBox === 'labelBase'){
      parENt.parent().parent().parent().parent().removeClass('active');
    }else{
      parENt.hide();
    }
  });
}

function updateFont(activeOb){
  if(activeOb){
    sCAle = activeOb.scaleX;
    activeOb.set('fontSize',fontSize);
    activeOb.set('fontFamily',fontFamily);
    activeOb.set('fill',activeCOLOR);
    activeOb.scaleX = .5;
    activeOb.setCoords();
    canvas.renderAll();
    activeOb.scaleX = sCAle;
    activeOb.setCoords();
    canvas.renderAll();
  }
}

jQuery(document).on('click','.dropper-eyedrop',function(){
  const eyeDropper = new EyeDropper();
  eyeDropper.open().then(result => {
    jQuery(this).parent().parent().parent().colorpicker('setValue', result.sRGBHex);
  }).catch(e => {
    console.error(e);
  });
});




jQuery(window).on('load',function(){
  canvasBlock(canvas2);
  window['text1Page'].set('text','Moonlit Souls');
  window['text4Page'].set('text', jQuery('#text_4').val() || 'Hamza');
  window['text5Page'].set('text', jQuery('#text_5').val() || 'Fizza');
  window['text6Page'].set('text', jQuery('#text_6').val() || 'Asif');
  window['text2Page'].set('text','Three souls, one beautiful story \nforever connected beneath the same moon.');
  window['canvas2'].renderAll();
  // loadFirstImg();
});


function getCookie(name){
  let nameEQ = name + "=";
  let cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++){
    let cookie = cookies[i].trim();
    if(cookie.indexOf(nameEQ) === 0){
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
}

window.addEventListener("load", function(){
  if(getCookie("firstVisit")){
    console.log("✅ Cookie exists:", getCookie("firstVisit"));
  } else{
    console.log("❌ Cookie does not exist!");
    document.cookie = "firstVisit=textresizing; expires=" + new Date(Date.now() + 24 * 60 * 60 * 1000).toUTCString() + "; path=/;";
    location.reload();
  }
});



/* fetch Call */
var size,thumbnail;
var loadedObject,moonDate,moonDate2,moonDate3,selectlocation,moonColor,moonColor2,moonColor3,firstName,secondName,thirdName,allNameFont,enterText,textFont,coordinates,enterQuote,quoteFont,frameColorBox,additionalInfo,wMark,svgMrk;
let pdfData = {};
jQuery(document).on('click','#download',function(){
  loader.removeClass('hidden');
  setTimeout(function(){
    resizeObjects(window['canvas2']);
    const id = ['canvas2'];
    const canvas = window['canvas2'];
    size = 406;
    loadMark(id,canvas,size);
    size = 4000;
    removeMark(canvas,size);
    // hideExtras(canvas);
    canvas.remove(currentImage);
    window['canvas2'] = canvas.toDataURL('image/png');
    moonDate = jQuery('#moon_date').val();
    moonDate2 = jQuery('#moon_date2').val();
    moonDate3 = jQuery('#moon_date3').val();
    selectlocation = jQuery('.location_map input').val();
    moonColor = jQuery('#moon_style option:selected').val();
    moonColor2 = jQuery('#moon_style2 option:selected').val();
    moonColor3 = jQuery('#moon_style3 option:selected').val();
    firstName = jQuery('#text_4').val();
    secondName = jQuery('#text_5').val();
    thirdName = jQuery('#text_6').val();
    enterText = jQuery('.enter_text input').val();
    textFont = jQuery('.choose_font1 option:selected').val();
    allNameFont = jQuery('.choose_font4 option:selected').val();
    coordinates = jQuery('.coordinates_map input').val();
    enterQuote = jQuery('.enter_quote textarea').val();
    frameColorBox = jQuery('.frameColorBox option:selected').val();
    quoteFont = jQuery('.choose_font2 option:selected').val();
    additionalInfo = jQuery('.tShirtImg textarea').val();
    // showExtras(canvas);
    canvasBlock(canvas);
    console.log(window['canvas2']);
    fetch('//technology-architects.com/tasweer-modules/save_order.php',{
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body:  JSON.stringify({
        temp_image: window['canvas2t'],
        original_image: window['canvas2']
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      var previewId = data[0],
          extraImg1 = data[1];
      jQuery('#previewImg').val(previewId);
      jQuery('#preExtraImg').val(extraImg1);
      jQuery('#moonDate').val(moonDate);
      jQuery('#moonDate2').val(moonDate2);
      jQuery('#moonDate3').val(moonDate3);
      jQuery('#selectlocation').val(selectlocation);
      jQuery('#moonColor').val(moonColor);
      jQuery('#moonColor2').val(moonColor2);
      jQuery('#moonColor3').val(moonColor3);
      jQuery('#firstName').val(firstName);
      jQuery('#secondName').val(secondName);
      jQuery('#thirdName').val(thirdName);
      jQuery('#allNameFont').val(allNameFont);
      jQuery('#enterText').val(enterText);
      jQuery('#textFont').val(textFont);
      jQuery('#coordinates').val(coordinates);
      jQuery('#enterQuote').val(enterQuote);
      jQuery('#frameColorBox').val(frameColorBox);
      jQuery('#quoteFont').val(quoteFont);
      jQuery('#addInfo').val(additionalInfo);
      console.log('Server response:', data);
      jQuery('.product-form__buttons .product-form__submit').trigger('click');
      loader.addClass('hidden');
    })
    .catch(error => console.error('Error uploading images:', error));
  },100);
});




function resizeObjects(canvas){
  if (typeof starBackground !== 'undefined') starBackground.setCoords();
  Object.keys(window.moonObjects || {}).forEach(function(key) {
    if (window.moonObjects[key]) window.moonObjects[key].setCoords();
  });
  if (window['text1Page']) window['text1Page'].setCoords();
  if (window['text2Page']) window['text2Page'].setCoords();
  if (window['text3Page']) window['text3Page'].setCoords();
  if (window['text4Page']) window['text4Page'].setCoords();
  if (window['text5Page']) window['text5Page'].setCoords();
  if (window['text6Page']) window['text6Page'].setCoords();
  if (window['text55Page']) window['text55Page'].setCoords();

  canvas.renderAll();

  var designResiz = new fabric.Group([
    starBackground,
    window.moonObjects && window.moonObjects[1],
    window.moonObjects && window.moonObjects[2],
    window.moonObjects && window.moonObjects[3],
    window['text1Page'],
    window['text2Page'],
    window['text3Page'],
    window['text4Page'],
    window['text5Page'],
    window['text6Page'],
    window['text55Page']
  ].filter(Boolean));

  designResiz.set({
    left: halfWidth,
    top: halfHeight,
    originX: 'center',
    originY: 'center'
  });

  var designResizScale = Math.min(
  (cWidth - 20) / designResiz.width,
  (cHeight - 20) / designResiz.height
);
designResiz.scale(designResizScale);
  designResiz.setCoords();
  canvas.renderAll();
}




function loadMark(id,canvas,size){
  wMark = document.getElementById('wm_collage');
  svgMrk = wMark.innerHTML;
  fabric.loadSVGFromString(svgMrk, function(objects,options){
    loadedObject = fabric.util.groupSVGElements(objects, options);
    loadedObject.scaleToWidth(cWidth);
    loadedObject.set({
      left: cWidth / 2,
      top: cHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false
    });
    canvas.add(loadedObject);
    loadedObject.bringToFront();
    loadedObject.setCoords();
    canvas.remove(currentImage);
    canvas.renderAll();
  });
  canvasMakeImg(canvas,size);
  window[id+'t'] = canvas.toDataURL('image/png');
  console.log(window[id+'t']);
}

function removeMark(canvas,size){
  canvas.remove(loadedObject).renderAll();
  canvasMakeImg(canvas,size);
}